export default __webpack_public_path__ + "static/media/element_spec_92.236f5dcc.jpg";